<template>
  <div>
    <el-dialog title="账号绑定" :visible="boundIDVisible" width="70%" center @close="visibleClose" :close-on-click-modal="false">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="绑定账号" name="first">
          <el-button type="primary" @click="addID">新增</el-button>
          <div style="margin-top:10px">
            <el-table border center size="mini" :data="tableData" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row height="300">
              <el-table-column label="操作" width="180">
                <template v-slot='scope'>

                  <el-button type="text" @click="bindRow(scope.row)" v-show="scope.row.twoway_bind == 1">授权互绑</el-button>
                  <el-button type="text" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="账号" prop="user_account"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="互绑状态" prop="twoway_bind">
                <template v-slot='scope'>
                  <span v-if="scope.row.twoway_bind==1">未互绑</span>
                  <span v-else>已互绑</span>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="用户名称" prop="user_name"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="租户名称" prop="tenant_name"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="绑定时间" prop="create_time" :formatter="dateTimeFormat"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="被绑账号" name="second">
          <div style="margin-top:10px">
            <el-table border center size="mini" :data="tableDataBind" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row height="300">
              <el-table-column label="操作" width="180">
                <template v-slot='scope'>
                  <el-button type="text" @click="deleteRowbind(scope.row)">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="账号" prop="user_account"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="互绑状态" prop="twoway_bind">
                <template v-slot='scope'>
                  <span v-if="scope.row.twoway_bind==1">未互绑</span>
                  <span v-else>已互绑</span>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="用户名称" prop="user_name"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="租户名称" prop="tenant_name"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" label="绑定时间" prop="create_time" :formatter="dateTimeFormat"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog :title="addTitle" :visible.sync="addVisible" width="35%" center @close="addVisible = false" class="boundStyle" :close-on-click-modal="false">
      <el-form size="mini" ref="formData" label-width="150px" :model="formData" style="width: 500px; margin: 15px auto" :rules="Rules">
        <el-form-item label="登录账号：" prop="userAccount">
          <el-input size="mini" style="width:215px;" v-model="formData.userAccount" autocomplete='new-password' @change="userChange"></el-input>
        </el-form-item>
        <el-form-item label="登录密码：" prop="userPwd" style="position:relative">
          <el-input size="mini" style="width:215px;" v-model="formData.userPwd" @blur="userPwdJY(formData.userPwd)" type="password" autocomplete='new-password'></el-input>
          <span style="color:red;margin-left:5px;font-size:26px;position:absolute;" v-if="PwdShow">×</span>
          <span style="color:green;margin-left:5px;font-size:26px;position:absolute;" v-else>√</span>
        </el-form-item>
        <el-form-item label="用户名称：" prop="username">
          <el-input size="mini" style="width:215px;" v-model="formData.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="租户名称：" prop="tenantName">
          <el-input size="mini" style="width:215px;" v-model="formData.tenantName" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" prop="mobile">
          <el-input size="mini" style="width:120px;" v-model="formData.mobile" @blur="shoujiBlur(formData.mobile)" disabled></el-input>
          <el-button type="primary" size="mini" style="margin-left:5px" @click="sendNumber" v-if="isShowGetCode" :disabled='disabledCode'>发送验证码</el-button>
          <span v-else class="identiCode cancel-pointer" style="margin-left:5px">{{ countdown }}s后可重试</span>
        </el-form-item>
        <el-form-item label="验证码：" prop="checkCode">
          <el-input size="mini" style="width:215px;" v-model="formData.checkCode"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="addIDVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { BindAccountList, checkUserPwd, sendSmsCode, saveBindAccount, deleteZH, twowayBind, passiveBindList } from '@/api/newCrm'
import { encryption, dateTimeFormat } from '@/utils/util'
export default {
  data () {
    return {
      dateTimeFormat,
      activeName: 'first',
      tableData: [],
      addTitle: '',
      addVisible: false,
      formData: {},
      PwdShow: true,
      phone: '',
      bindUserId: '',
      changeData: [],
      isShowGetCode: true,
      countdown: 60,
      timer: '',
      Rules: {
        userAccount: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        userPwd: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        tenantName: [
          { required: true, message: '请输入租户名称', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        checkCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      tableDataBind: [],
      disabledCode: false
    }
  },
  props: {
    boundIDVisible: {
      type: Boolean
    }
  },
  created () {
    this.BindAccountList()
  },
  methods: {
    // 账号绑定关闭
    visibleClose () {
      this.$emit('update:boundIDVisible', false)
    },
    // tab页签点击
    handleClick () {
      if (this.activeName == 'second') {
        this.passiveBindList()
      } else if (this.activeName == 'first') {
        this.BindAccountList()
      }
    },
    // 登录账号改变
    userChange () {
      this.$set(this.formData, 'username', '')
      this.$set(this.formData, 'tenantName', '')
      this.$set(this.formData, 'mobile', '')
      this.$set(this.formData, 'userPwd', '')
    },
    // 登录密码检验对错
    userPwdJY (val) {
      console.log(this.formData.userPwd)
      let userPwd = encryption({
        // userPwd: this.formData.userPwd,
        key: 'soc1234567890soc',
        param: ['userPwd'],
        data: this.formData
      })
      let userPassword = userPwd.userPwd
      checkUserPwd(
        {
          userAccount: this.formData.userAccount,
          userPwd: userPassword
        }
      ).then(res => {
        console.log(res)
        this.PwdShow = false
        this.disabledCode = false
        this.bindUserId = res.id
        this.phone = res.mobile
        let reg = /^(\d{3})\d*(\d{4})$/
        let mobile = res.mobile.replace(reg, '$1****$2')
        this.$set(this.formData, 'username', res.user_name)
        this.$set(this.formData, 'tenantName', res.NAME)
        this.$set(this.formData, 'mobile', mobile)
      })
        .catch(error => {
          if (error.code == -1) {
            this.PwdShow = true
            this.$set(this.formData, 'username', '')
            this.$set(this.formData, 'tenantName', '')
            this.$set(this.formData, 'mobile', '')
            this.disabledCode = true
          }
          // this.$message.error(error.message)
        })
    },
    // 新增账号
    addID () {
      this.disabledCode = true
      this.formData = {}
      this.PwdShow = true
      this.countdown = 60
      clearInterval(this.timer)
      this.isShowGetCode = true
      this.addVisible = true
      this.addTitle = '新增绑定'
      this.$refs.formData.clearValidate()
    },
    // 绑定账号确定
    addIDVisible () {
      this.$refs.formData.validate((val) => {
        if (val) {
          saveBindAccount({
            bindUserId: this.bindUserId,
            userAccount: this.phone,
            checkCode: this.formData.checkCode
          }).then(res => {
            console.log(res)
            this.addVisible = false
            this.addTitle = ''
            this.formData = {}
            this.BindAccountList()
            this.$emit('BindAccountList')
          })
            .catch(error => {
              this.$message.error(error.message)
            })
        }
      })
    },
    // 账号绑定
    BindAccountList () {
      BindAccountList().then(res => {
        console.log(res)
        this.tableData = res
        this.changeData = res
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 账号绑定按钮
    bindRow (row) {
      this.$confirm(`允许"${row.user_account}"绑定当前账号？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        console.log(res)
        twowayBind({ id: row.id }).then(res => {
          console.log(res)
          this.$message.success('绑定成功')
          this.BindAccountList()
        })
          .catch(error => {
            this.$message.error(error.message)
          })
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 账号绑定删除
    deleteRow (row) {
      this.$confirm('确认删除绑定账号吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        console.log(res)
        deleteZH({ id: row.id }).then(res => {
          console.log(res)
          this.$message.success('删除成功')
          this.BindAccountList()
          this.$emit('BindAccountList')
        })
          .catch(error => {
            this.$message.error(error.message)
          })
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 发送验证码
    sendNumber () {
      console.log(this.formData.mobile)
      if (this.formData.mobile != undefined && this.formData.mobile != '') {
        this.isShowGetCode = false
        const self = this
        this.timer = setInterval(() => {
          self.countdown--
          if (self.countdown === 0) {
            clearInterval(self.timer)
            self.countdown = 60
            self.isShowGetCode = true
          }
        }, 1000)
        sendSmsCode(
          { userAccount: this.phone }
        ).then(res => {
          console.log(res)
        })
          .catch(error => {
            this.$message.error(error.message)
          })
      }
    },
    // 手机号处理
    shoujiBlur (val) {
      console.log(val)
      this.phone = val
      let reg = /^(\d{3})\d*(\d{4})$/
      this.formData.mobile = val.replace(reg, '$1****$2')
    },
    deleteRowbind (row) {
      this.$confirm('确认删除绑定账号吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        console.log(res)
        deleteZH({ id: row.id }).then(res => {
          console.log(res)
          this.$message.success('删除成功')
          this.passiveBindList()
          this.$emit('BindAccountList')
        })
          .catch(error => {
            this.$message.error(error.message)
          })
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    passiveBindList () {
      passiveBindList().then(res => {
        console.log(res)
        this.tableDataBind = res
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    }
  }
}
</script>

<style>
</style>
